var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ms-tabs ms-flex-middle"},_vm._l((_vm.tabList),function(item,index){return _c('div',{key:item.id,staticClass:"ms-tab-item",class:{active: index == _vm.active},on:{"click":function($event){return _vm.handleTabClick(index)}}},[_vm._v(_vm._s(item.name))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }